import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import RentableForm from '../Form';
import { createRentable } from '@resources/Rentable/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createRentable, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createRentable(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.rentable.create',
						defaultMessage:
							'A new Rentable has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.rentable',
					defaultMessage: 'Create Rentable',
				})}
			</Title>
			<RentableForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	rentables,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		rentables,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createRentable,
	fetchModulesBySubmoduleCode,
})(Create);
